import React from 'react';
import useI18nInstance from '../hooks/useI18nInstance';

interface IProps {
  language: string,
  children: React.ReactNode,
}

const LocalizedContent = ({ children, language }: IProps) => {
  const i18nInstance = useI18nInstance();

  if (i18nInstance.language !== language) {
    return null;
  }

  return children;
};

export default LocalizedContent;
